module.exports = __webpack_public_path__ + "static/media/img-26419d96.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth/images/background.png
// module id = 5308
// module chunks = 39